import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    isLoggedIn: Observable<boolean>;

    constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLoggedIn = localStorage.getItem('isLoggedIn'); // Check login status

    // Clone the request to add the Authorization header if the user is logged in
    if (isLoggedIn === 'true') {
      const clonedRequest = request.clone({
        setHeaders: {
          Authorization: 'turoboauthkey'
        }
      });
      return next.handle(clonedRequest); // Forward the cloned request
    }

    return next.handle(request); // Forward the original request if not logged in
  }


}
